import { render, staticRenderFns } from "./CampStudentCalls.vue?vue&type=template&id=164d2e6b&"
import script from "./CampStudentCalls.vue?vue&type=script&lang=js&"
export * from "./CampStudentCalls.vue?vue&type=script&lang=js&"
import style0 from "./CampStudentCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports